<template>
  <div class="newsPage">
    <div class="top">
        <img src="../img/logo.png" alt="">
      <div class="line"></div>
      <img src="../img/min_title.png" alt=""  class="imgRight">
    </div>
    <div class="main">
      <div class="title">历久弥新 赋能未来 • 往届回顾</div>
      <div class="history">
          <div class="historyItem" @click="toDetail('http://conference.hanban.org/pc/index.html')">
              <img src="../img/history2018.jpg" alt="">
              <div class="itemInfo">
                  <div>2018</div>
                  <div>改革创新促发展</div>
                  <div>
                      携手同心创未来
                  </div>
              </div>
          </div>
          <div class="historyItem" @click="toDetail('http://conference2017.chinesecio.com/')">
              <img src="../img/history2017.jpg" alt="">
              <div class="itemInfo">
                  <div>2017</div>
                  <div>深化合作 创新发展</div>
                  <div>
                      为构建人类命运共同体贡献力量
                  </div>
              </div>
          </div>
          <div class="historyItem" @click="toDetail('http://conference2017.chinesecio.com/2016/confucius/index.html')">
              <img src="../img/history2016.jpg" alt="">
              <div class="itemInfo">
                  <div>2016</div>
                  <div>创新 合作 包容 共享</div>
              </div>
          </div>
          <div class="arrow">
              <img src="../img/big_arrow.png" alt="" @click="toDetail('http://conference2017.chinesecio.com/2016/confucius/index.html')">
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "history",
  data: function() {
    return {
      
    };
  },
  methods: {
          // 根据图片宽高比动态显示不同样式
    loadImg (dom, i, e) {
        var wrapperWidth = $(dom).width()
        var wrapperHeight = $(dom).height()
        if(e.target.naturalWidth/e.target.naturalHeight - (wrapperWidth/wrapperHeight) > 0){
            this.$set(this.newsList[i], 'toWidth', false)
        $(e.target).css('transform','translateX(-'+(e.target.width-wrapperWidth)/2+'px)')
        }else {
            this.$set(this.newsList[i], 'toWidth', true)
            $(e.target).css('height', 'auto')
            var radio = wrapperWidth/e.target.naturalWidth
            $(e.target).css('transform','translateY(-'+(e.target.height*radio-wrapperHeight)/2+'px)')
        }
    },

    toDetail(link) {
        window.open(link)
    }
  },
  mounted() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this compone nt only -->
<style scoped lang="scss">
.newsPage {
  .top {
    margin-left: 55px;
    padding-top: 30px;
    .line {
      display: inline-block;
      width: 1px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0 45px;
      vertical-align: super;
    }
  }
  .main {
    margin-left: 240px;
    //float: right;
    .title {
      font-size: 60px;
      color: #f3bc65;
      font-weight: bold;
      margin: 28px 120px;
    }
    .history {
         margin: 28px 120px;
    }
    .historyItem {
        display: inline-block;
        position: relative;
        width: 350px;
        height: 550px;
        border: 1px solid #fff;
        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3);
        border-radius: 30px;
        margin-right: 24px;
        cursor: pointer;
        overflow: hidden;
        transition: width linear 0.5s;
        img {
            transform: translateX(-100px);
            transition: all linear 0.5s;
        }
        .itemInfo {
            position: absolute;
            bottom: 24px;
            left: 20px;
            font-size: 20px;
            color: #fff;
            font-weight: bold;
            line-height: 1.2;
            div:first-child {
                font-size: 80px;
                color: #fff;
                margin-bottom: 28px;
            }
        }
    }
    .arrow {
        display: inline-block;
        height: 550px;
        line-height: 550px;
        vertical-align: top;
        img {
            margin: auto;
            cursor: pointer;
            
        }
    }
    .historyItem:last-child .itemInfo {
            bottom: 48px;
        }
    .historyItem:hover {
        width: 550px;
        img {
            transform: translateX(0px);
        }
    }



  }
}

@media screen and (min-width: 1240px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .history {
            margin: 28px 0;
            .historyItem {
                height: 485px;
                width: 300px;
                .itemInfo {
                    font-size: 18px;
                    div:first-child {
                        font-size: 60px;
                    }
                }
                img {
                     transform: translateX(-150px);
                     transition: all linear 0.5s;
                }
                
            }
            .historyItem:hover {
                width: 430px;
                img {
                    transform: translateX(0px);
                }
            }
            
        }
    }
}

  
}

@media screen and (min-width: 1460px) and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            margin: 28px 60px;
        }
        .history {
            margin: 28px 60px;
        }
    }
}

  
}
</style>
